/** @file fillRect: overwrites a rectangle of an image with one colour, clipped to the image. */
import type { Image, Rgba } from '../types/image';

/** Sets every pixel of `[x, x + w) × [y, y + h)` inside `dst` to `color` (no blending). */
export function fillRect(dst: Image, x: number, y: number, w: number, h: number, color: Rgba): void {
  const x0 = Math.max(0, x);
  const y0 = Math.max(0, y);
  const x1 = Math.min(dst.width, x + w);
  const y1 = Math.min(dst.height, y + h);
  for (let row = y0; row < y1; row++) {
    for (let col = x0; col < x1; col++) dst.data.set(color, (row * dst.width + col) * 4);
  }
}
